import { CATALOG_SERVICE_URL, QUOTE_SERVICE_URL, DELETE_VENDOR_PRICES, AUTOMATIC_FOLLOW_UP } from "../../libs/constants";
import app from './app';
import { saveAs } from 'file-saver';

const getCTInitialQuoteDetail = (userId, quoteId) => async (dispatch, getState, api) => {
    const url = QUOTE_SERVICE_URL + "/" + userId + "/" + quoteId;
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getCTInitialQuoteDetail"
        }
    };

    dispatch(app.setLoading(true));

    await api.post(url, {}, headerConfig)
        .then(response => {
            if (response.data) {
                dispatch({
                    type: "SET_CT_INITIAL_QUOTE_DETAIL",
                    payload: response.data
                });
            }
            if(response.data.vendorQuoteDetails) {
                const refusedVendors = Object.entries(response.data.vendorQuoteDetails)
                    .filter(([_, details]) => details.refused === true)
                    .map(([vendor]) => vendor);
                    dispatch({
                        type: "SET_REFUSED_VENDORS",
                        payload: refusedVendors
                    });
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            console.log(error);
        });
};

const uploadCustomerFormFile = (requestData, fileName, userId, countryList) => async (dispatch, getState, api) => {
    const config = {
        headers: {
            'content-type': 'multipart/form-data',
            'countryList': countryList.join(",")
        }
    }
    await api.post(QUOTE_SERVICE_URL + "/file/upload/" + userId, requestData, config)
        .then(response => {
            if (response.data.quoteId) {
                dispatch(setFileName(fileName));
                dispatch(setQuoteId(response.data.quoteId));
                dispatch(setCTInitialQuoteField(
                    "quoteId", response.data.quoteId
                ))
                dispatch(setFileUploadStatus("success"));
                dispatch({ type: "SET_FILE_UPLOAD_STATUS_DESC", value: '' });
            }
            else {
                dispatch(setQuoteId(""));
                dispatch(setFileUploadStatus("error"));
            }
        })
        .catch(error => {
            dispatch(setQuoteId(""));
            dispatch(setFileUploadStatus("error"));
            dispatch({ type: "SET_FILE_UPLOAD_STATUS_DESC", value: error?.response?.data?.message || '' });
        });
}

const downloadExcel = (userId, quoteId, actionType) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    const fileName = actionType === "partially_created" ?
        `CTQuote_${quoteId}_CustomerVersion_Partial_Quote.xlsx` :
        `CTQuote_${quoteId}_CustomerVersion.xlsx`;
    let apiEndPointUrl = QUOTE_SERVICE_URL + `/downloadExcel/${userId}/${quoteId}`;
    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        },
        responseType: "blob"
    };
    await api.post(apiEndPointUrl, null, downloadConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            saveAs(new Blob([response.data]), fileName);
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const downloadFMVFile = (userId, fileName) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    let apiEndPointUrl = QUOTE_SERVICE_URL + `/pyxtech/download/${userId}/${fileName}`;
    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        },
        responseType: "blob"
    };
    await api.post(apiEndPointUrl, null, downloadConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            saveAs(new Blob([response.data]), fileName);
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const refreshFMVFile = (userId, quoteId) => async (dispatch, getState, api) => {
    const url = QUOTE_SERVICE_URL + "/pyxtechData/" + userId + "/" + quoteId;
    const headerConfig = {
        headers: {
            "isRefresh": true
        }
    };

    dispatch(app.setLoading(true));

    await api.post(url, {}, headerConfig)
        .then(response => {
            console.log(response.data);
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            console.log(error);
        });
}

const downloadPartialExcel = (userId, quoteId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    let apiEndPointUrl = QUOTE_SERVICE_URL + `/partialCreated/downloadExcel/${userId}/${quoteId}`;
    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        },
        responseType: "blob"
    };
    await api.post(apiEndPointUrl, null, downloadConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            saveAs(new Blob([response.data]), `CTQuote_${quoteId}_CustomerVersion_Partial_Quote.xlsx`);
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const downloadVendorFile = (requestData, userId, quoteId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    let apiEndPointUrl = QUOTE_SERVICE_URL + `/download/vendorprice/${userId}/${quoteId}`;
    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        },
        responseType: "blob"
    };
    await api.post(apiEndPointUrl, requestData, downloadConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            saveAs(new Blob([response.data]), `${quoteId}_Prices${requestData.vendorName}.xlsx`);
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const downloadHpRevitalizeFile = (userId, quoteId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    let requestData = {};
    let apiEndPointUrl = QUOTE_SERVICE_URL + `/download/prePriceUploadByHP/${userId}/${quoteId}`;
    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        },
        responseType: "blob"
    };
    await api.post(apiEndPointUrl, requestData, downloadConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            saveAs(new Blob([response.data]), `${quoteId}_Prices_HP_Revitalize.xlsx`);
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const getVendors = (requestData, userId) => async (dispatch, getState, api) => {
    requestData.requestorType = requestData.requestorType || "direct";
    await api.post(CATALOG_SERVICE_URL + "countries/vendors/" + userId, requestData)
        .then(response => {
            if (response.data.vendorHeaders && response.data.countryVendors) {
                dispatch(setVendorList(response.data.vendorHeaders));
                dispatch(setVendorSelectionData(response.data, true, true));
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
            }
        })
        .catch(error => {
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
}
const getPriceLists = () => async (dispatch, getState, api) => {
    await api.post(CATALOG_SERVICE_URL + "priceList/HardwareAndService", {})
        .then(response => {
            if (response.data.priceList) {
                dispatch(setCTInitialQuoteField("priceLists", response.data.priceList));
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
            }
        })
        .catch(error => {
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
}
const getServicePriceLists = () => async (dispatch, getState, api) => {
    await api.post(CATALOG_SERVICE_URL + "priceList/Service", {})
        .then(response => {
            if (response.data.priceList) {
                dispatch(setCTInitialQuoteField("servicePriceLists", response.data.priceList));
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
            }
        })
        .catch(error => {
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
}

const sendQuoteMail = (userId, requestObj) => async (dispatch, getState, api) => {
    await api.post(QUOTE_SERVICE_URL + "/send/email/" + userId, requestObj)
        .then(response => {
            if (response.data) {
                dispatch(app.setAppModal({ type: "info", messageId: "quote_email_success" }));
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
            }
        })
        .catch(error => {
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
}

const saveMargins = (requestData, userId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    await api.post(QUOTE_SERVICE_URL + '/saveMargin/' + userId, requestData)
        .then(_response => {
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const getHPMargins = (requestData, userId) => async (dispatch, getState, api) => {
    try {
        const response = await api.post(QUOTE_SERVICE_URL + '/hpmargins/' + userId, requestData);
        if (response.data.costMarginsResponses) {
            const marginData = response.data.costMarginsResponses;
            const marginCombinedData = [
                ...(marginData["payment1.1"] || []),
                ...(marginData["payment1.0"] || [])
            ];

            if (marginData.hasOwnProperty("payment1.1") || marginData.hasOwnProperty("payment1.0")) {
                dispatch({
                    type: "UPDATE_CT_INITIAL_QUOTES_PAYMENT_ONE_POINT_ONE_MARGIN_DATA",
                    data: marginCombinedData
                });
            } else {
                dispatch(resetPaymentOnePointOneDefaultMargins());
                dispatch({
                    type: "UPDATE_CT_INITIAL_QUOTES_PAYMENT_ONE_POINT_ONE_MARGIN_DATA",
                    data: []
                });
            }

            // if (marginData.hasOwnProperty("payment1.0")) {
            //     dispatch({
            //         type: "UPDATE_CT_INITIAL_QUOTES_PAYMENT_ONE_POINT_O_MARGIN_DATA",
            //         data: marginData["payment1.0"]
            //     });
            // }
            // else {
            //     dispatch(resetPaymentOnePointODefaultMargins());
            //     dispatch({
            //         type: "UPDATE_CT_INITIAL_QUOTES_PAYMENT_ONE_POINT_O_MARGIN_DATA",
            //         data: []
            //     });
            // }
        }
    } catch (error) {
        //
    }
};

const generateCTInitialQuote = (requestData, callback) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    await api.post(QUOTE_SERVICE_URL + '/direct/generateQuote', requestData)
        .then(response => {
            dispatch(app.setLoading(false));
            dispatch({
                type: "SET_NEW_CT_INITIAL_QUOTE_CREATED",
                data: response.data
            });
            callback && callback();
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const getRefusedReasonList = (userId) => async (dispatch, getState, api) => {
    const url = CATALOG_SERVICE_URL + "refuseBidOptions" + "/" + userId;
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getRefusedReasonList"
        }
    };

    dispatch(app.setLoading(true));

    await api.get(url, {}, headerConfig)
        .then(response => {
            if (response.data) {
                dispatch({
                    type: "SET_REFUSED_REASON_LIST",
                    payload: response.data
                });
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            console.log(error);
        });
};

const saveCTInitialQuote = (requestData) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    await api.post(QUOTE_SERVICE_URL + '/direct/saveQuote', requestData)
        .then(response => {
            dispatch(app.setLoading(false));
            if (response.data.status) {
                dispatch({
                    type: "SET_NEW_CT_INITIAL_QUOTE_SAVED",
                    data: requestData.action
                });
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
            }
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const requestPrices = (requestData, callback) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getCTInitialQuoteDetails" } };
        await api.post('/quote/direct/requestQuote', requestData, headerConfig);

        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "info", messageId: "request_prices_success" }));
        callback && callback();
    } catch (error) {
        console.log(error);
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const deleteCtQuoteFiles = (quoteId, userId, vendorname) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    await api.post(DELETE_VENDOR_PRICES + '/' + userId + '/' + quoteId + '/' + vendorname)
        .then(_response => {
            dispatch(app.setLoading(false));
            dispatch(getCTInitialQuoteDetail(userId, quoteId));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const automaticFollowUp = (quoteId, vendorname, followUpFlag) => async (dispatch, getState, api) => {
    if (followUpFlag !== true) {
        followUpFlag = 'no'
    }
    else {
        followUpFlag = 'yes'
    }
    dispatch(app.setLoading(true));
    await api.post(AUTOMATIC_FOLLOW_UP + '/' + quoteId + '/' + vendorname + '?followUpFlag=' + followUpFlag)
        .then(_response => {
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const updateFollowUpFlagToggle = (switcherState, vendorName) => {
    return {
        type: 'UPDATE_FOLLOW_UP_FLAG_TOGGLE',
        data: { switcherState, vendorName }
    }
}

const updateRefusedFlag = (refused, vendorName) => {
    return {
        type: 'UPDATE_REFUSED_FLAG',
        data: { refused, vendorName }
    }
}

const refuseVendor = (userId, quoteId, requestData) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    const headerConfig = { headers: { "DRS-Fetch-Type": "refuseVendor" } };
    await api.post('/quote/refuseVendor/' + userId + "/" + quoteId, requestData, headerConfig)
        .then(res => {
            dispatch(getCTInitialQuoteDetail(userId, quoteId));
        })
        .catch(error => {
            if (error?.response?.data && error?.response?.data?.errorCode === 500) {
                dispatch(app.setAppModal({ type: "error", messageText: error.response.data.message }));

            } else {
                console.log(error);
                dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
            }
            dispatch(getCTInitialQuoteDetail(userId, quoteId));
        });
    dispatch(app.setLoading(false));
};

const updateRefusedReason = (refusedReason, vendorName) => {
    return {
        type: 'UPDATE_REFUSED_REASON',
        data: { refusedReason, vendorName }
    }
}

const setVendorSelectionData = (vendorData, needsTransformation, constructVendorDataCopy) => {
    return {
        type: 'SET_CT_INITIAL_QUOTES_VENDOR_DATA',
        data: { vendorData, needsTransformation, constructVendorDataCopy }
    }
}

const setVendorList = (vendorList) => {
    return {
        type: 'SET_CT_INITIAL_QUOTE_VENDOR_LIST',
        data: vendorList
    }
}

const setVendorSelection = option => {
    return {
        type: "SET_CT_INITIAL_QUOTES_VENDOR_SELECTION",
        data: option
    }
}

const resetPaymentOnePointOneDefaultMargins = () => {
    return {
        type: 'RESET_PAYMENT_ONE_POINT_ONE_DEFAULT_MARGINS',
        data: []
    }
}

const resetPaymentOnePointODefaultMargins = () => {
    return {
        type: 'RESET_PAYMENT_ONE_POINT_O_DEFAULT_MARGINS',
        data: []
    }
}

const updatePaymentOnePointOneMarginData = marginData => {
    return {
        type: 'UPDATE_CT_INITIAL_QUOTES_PAYMENT_ONE_POINT_ONE_MARGIN_DATA',
        data: marginData
    }
}

const updatePaymentOnePointOMarginData = marginData => {
    return {
        type: 'UPDATE_CT_INITIAL_QUOTES_PAYMENT_ONE_POINT_O_MARGIN_DATA',
        data: marginData
    }
}

const updateCountryList = countryList => {
    return {
        type: 'UPDATE_CT_INITIAL_QUOTES_COUNTRY_LIST',
        data: countryList
    }
}

const setQuoteId = quoteId => {
    return {
        type: "SET_QUOTE_ID",
        data: quoteId
    }
}
const setFileUploadStatus = status => {
    return {
        type: "SET_FILE_UPLOAD_STATUS",
        data: status
    }
}
const setRateCardSelection = option => {
    return {
        type: "SET_CT_INITIAL_QUOTES_RATE_CARD_SELECTION",
        data: option
    }
}
const setRateConversionSelection = option => {
    return {
        type: "SET_CT_INITIAL_QUOTES_RATE_CONVERSION_SELECTION",
        data: option
    }
}
const setVendorMatrixSelections = vendorData => {
    return {
        type: "SET_VENDOR_MATRIX_SELECTIONS",
        data: vendorData
    }
}
const setVendorNetValues = netValues => {
    return {
        type: "SET_VENDOR_NET_VALUES",
        data: netValues
    }
}

const setUserSelectedTotalVendorNetValue = userSelectedTotalVendorNetValue => {
    return {
        type: "SET_USER_SELECTED_TOTAL_VENDOR_NET_VALUE",
        data: userSelectedTotalVendorNetValue
    }
}

const setMaxNetValue = maxNetValue => {
    return {
        type: "SET_MAX_NET_VALUE",
        data: maxNetValue
    }
}
const setConvertedVendorNetValues = netValues => {
    return {
        type: "SET_CONVERTED_VENDOR_NET_VALUES",
        data: netValues
    }
}
const setUserSelectedVendor = vendorName => {
    return {
        type: "SET_USER_SELECTED_VENDOR",
        data: vendorName
    }
}
const setCTInitialQuoteField = (id, value) => {
    return {
        type: "SET_CT_INITIAL_QUOTE_FIELD",
        data: { id, value }
    }
}
const updateTableData = data => {
    return {
        type: "UPDATE_TABLE_DATA",
        data: data
    }
}
const resetQuoteData = () => {
    return {
        type: "RESET_CT_INITIAL_QUOTE_DATA"
    }
}

const backButtonStatus = (status) => {
    return {
        type: "BACK_BUTTON_CLICKED",
        data: status
    }
}

const setFileName = fileName => {
    return {
        type: "SET_FILE_NAME",
        data: fileName
    }
}

const setVendorError = (message) => {
    return {
        type: "SET_VENDOR_ERROR",
        data: message
    }
}
const setCountryError = (message) => {
    return {
        type: "SET_COUNTRY_ERROR",
        data: message
    }
}

const quoteDetailsActions = {
    uploadCustomerFormFile,
    getCTInitialQuoteDetail,
    setFileName,
    setQuoteId,
    setFileUploadStatus,
    setVendorSelection,
    setRateCardSelection,
    setRateConversionSelection,
    updatePaymentOnePointOneMarginData,
    updatePaymentOnePointOMarginData,
    getHPMargins,
    updateCountryList,
    resetPaymentOnePointOneDefaultMargins,
    resetPaymentOnePointODefaultMargins,
    getVendors,
    setVendorSelectionData,
    setVendorList,
    setVendorMatrixSelections,
    setVendorNetValues,
    setUserSelectedVendor,
    getPriceLists,
    setCTInitialQuoteField,
    generateCTInitialQuote,
    saveCTInitialQuote,
    resetQuoteData,
    sendQuoteMail,
    updateTableData,
    backButtonStatus,
    setVendorError,
    setCountryError,
    downloadExcel,
    downloadPartialExcel,
    saveMargins,
    downloadVendorFile,
    downloadHpRevitalizeFile,
    requestPrices,
    setConvertedVendorNetValues,
    setUserSelectedTotalVendorNetValue,
    setMaxNetValue,
    deleteCtQuoteFiles,
    automaticFollowUp,
    updateFollowUpFlagToggle,
    getServicePriceLists,
    updateRefusedFlag,
    updateRefusedReason,
    getRefusedReasonList,
    refuseVendor,
    downloadFMVFile,
    refreshFMVFile
}

export default quoteDetailsActions;